import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueSelectImage from 'vue-select-image';

import axios from 'axios'
import VueAxios from 'vue-axios'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-select-image/dist/vue-select-image.css';

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

Vue.use(BootstrapVue)
Vue.use(VueSelectImage)
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
